// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"image-with-fallback_placeholder__6mvP9","fallbackText":"image-with-fallback_fallbackText__AiWYY"};